/* eslint-disable */
import { Theme, createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const styles = (theme: Theme) =>
  createStyles({
    globalCategory: {
      display: "flex",
      boxSizing: 'content-box',
      height: 'auto',
      flexDirection: "column",
      width: '100%',
      background: 'none',
      boxShadow: 'none',
      '& *': {
        boxSizing: 'content-box'
      }
    },
    globalCategoryTitle: {
      fontSize: '24px',
      fontWeight: 'bold' as any,
      lineHeight: '29px',
      boxSizing: 'content-box',
      padding: theme.spacing(3, 0) + ' !important',
      color: theme.palette.common.black,
      '&>div': {
        display: 'flex',
        alignItems: 'center',
      }
    },
    globalCategoryTitleIcon: {
      width: '8px',
      height: '5px',
      marginRight: theme.spacing(1),
      transform: 'rotate(-90deg)',
      '&.rotate': {
        transform: 'rotate(0deg)',
      }
    },
    globalCategoryBody: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'content-box',
      height: '100%',
    },
    globalCategoryRow: {
      width: '100%',
      padding: 0,
      display: 'flex',
      justifyContent: 'space-between',
      '&~&': {
        marginTop: theme.spacing(2)
      },
      boxSizing: 'content-box',
      height: '100%',
    }
  });

export const useStyles = makeStyles(styles);
